import type { SVGProps } from 'react';
import * as React from 'react';

const ChevronLeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/chevron-left">
      <path
        id="Icon"
        d="M7.71356 11.3637C7.36208 11.7152 7.36208 12.285 7.71356 12.6365L14.2136 19.1365C14.565 19.488 15.1349 19.488 15.4863 19.1365C15.8378 18.785 15.8378 18.2152 15.4863 17.8637L9.62274 12.0001L15.4863 6.13649C15.8378 5.78502 15.8378 5.21517 15.4863 4.8637C15.1349 4.51223 14.565 4.51223 14.2136 4.8637L7.71356 11.3637Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export default ChevronLeftIcon;
